module.exports = __webpack_public_path__ + "static/media/upload_more.243112c4.svg";